import { useLocation } from "react-router-dom";
import CityPage from "./CityPage";
import { useSEO } from "@/lib/hooks";

export default function CityCatchAll() {
  const { pathname } = useLocation();
  const clean = pathname.replace(/^\/+/, "").replace(/\/+$/, "");
  const PREFIX = "depannage-remorquage-";
  if (clean.startsWith(PREFIX)) {
    const slug = clean.slice(PREFIX.length);
    return <CityPage slug={slug} />;
  }
  return <NotFound />;
}

function NotFound() {
  useSEO({ title: "Page introuvable — Depann7" });
  return (
    <div className="bg-white min-h-[60vh] flex items-center justify-center px-6 text-center">
      <div>
        <div className="text-7xl font-extrabold text-brand">404</div>
        <div className="text-2xl font-bold text-txt-900 mt-2">Page introuvable</div>
        <p className="text-txt-500 mt-2">Le contenu demandé est introuvable.</p>
        <a href="/" className="mt-6 inline-block bg-brand hover:bg-brand-600 text-white font-bold rounded-xl px-6 py-3 transition-colors">Retour à l'accueil</a>
      </div>
    </div>
  );
}
